<template>
  <el-card
    v-loading="isloading"
    style="border: none"
    shadow="never"
    :body-style="{ padding: '10px' }"
  >
    <div slot="header" class="firstlog-path-chart-header">
      <span style="font-size: 14px; font-weight: bold"
        >{{ btm }}的访问记录</span
      >

      <el-switch
        v-model="dimension"
        active-text="用户"
        inactive-text="接口"
        active-color="#409EFF"
        inactive-color="#409EFF"
        style="margin-left: 20px"
      />

      <div style="flex-grow: 1; text-align: right">
        <el-dropdown
          trigger="click"
          @command="onServiceChange"
          @visible-change="serviceOpened = $event"
        >
          <span class="service-dropdown">
            {{ (service || 'all service').toUpperCase() }}
            <i
              class="el-icon-arrow-down service-down-icon"
              :class="{ opened: serviceOpened }"
            ></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="">ALL SERVICE</el-dropdown-item>
            <el-dropdown-item
              v-for="s in services"
              :key="s.value"
              :command="s.value"
            >
              {{ s.label }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <!-- <el-table :data="data || []" row-key="path" max-height="400" height="400">
            <el-table-column type="expand">
                <FirstlogPathDimensionTable slot-scope="scope" :items="scope.row.parts" @open-user="onOpenUser" />
            </el-table-column>
            <el-table-column prop="path" label="路径"></el-table-column>
            <el-table-column label="最多调用" width="220">
                <div slot-scope="scope">
                    <span class="info-uname">{{ scope.row.maxCallUser.uname }}</span>
                    <span>({{ scope.row.maxCallUser.count }})</span>
                </div>
            </el-table-column>
            <el-table-column label="数量(成功/总数量)" width="120" align="right">
                <div slot-scope="scope">
                    <span class="info-successful-count">{{ scope.row.successfulCount || 0 }}</span>
                    <span>/</span>
                    <span class="info-count">{{ scope.row.count }}</span>
                </div>
            </el-table-column>
        </el-table> -->

    <template v-if="dimension0">
      <FirstlogUserDimensionTable
        :items="data"
        component="FirstlogPathDimensionTable"
        @open-user="onOpenUser"
      />
    </template>
    <template v-else>
      <FirstlogPathDimensionTable
        :items="data"
        component="FirstlogUserDimensionTable"
        @open-user="onOpenUser"
      />
    </template>

    <el-dialog
      v-if="isopenUser"
      :visible.sync="isopenUser"
      width="1000px"
      top="60px"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <api-user
        v-if="openUser.type === 2"
        add-user-text="修改"
        :add-user-id="openUser.id"
        @closeUserDetail="isopenUser = false"
      />
      <web-user
        v-if="openUser.type === 1"
        update-user-text="修改"
        :update-user-id="openUser.id"
        @closeUpdateUser="isopenUser = false"
      />
    </el-dialog>
  </el-card>
</template>

<script>
import apiRequest from './api.request.js'
import FirstlogPathDimensionTable from './FirstlogPathDimensionTable.vue'
import FirstlogUserDimensionTable from './FirstlogUserDimensionTable.vue'
import ApiUser from '@/views/page/userManage/addNewUser.vue'
import WebUser from '@/views/page/userManage/moUserInfor.vue'

import { debounce } from 'lodash'

export default {
  components: {
    FirstlogPathDimensionTable,
    FirstlogUserDimensionTable,
    ApiUser,
    WebUser,
  },

  mixins: [apiRequest],

  props: {
    service: {
      type: String,
      default: () => '',
    },
    btm: {
      type: String,
      required: true,
    },
    etm: {
      type: String,
      required: true,
    },

    services: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      isloading: false,

      data: [],

      serviceOpened: false,

      isopenUser: false,
      openUser: {},

      dimension: false,

      dimension0: false,
    }
  },

  created() {
    const loaddata = debounce(this.loadData, 300)
    this.$watch(
      () => [this.service, this.btm, this.etm, this.dimension],
      loaddata,
      {
        immediate: true,
      }
    )

    this.loadAllServices().then(list =>
      this.$emit('update:services', list || [])
    )
  },

  methods: {
    async loadData() {
      if (this.btm && this.etm) {
        this.isloading = true

        try {
          const resp = await this.$api.get(
            '/schedules/apicallogs/firstlog/path/chart',
            {
              params: {
                service: this.service,
                btm: this.btm,
                etm: this.etm,
                dimension: this.dimension ? 'user' : 'path',
              },
            }
          )

          if (resp.data.status === 1) {
            this.data = resp.data.content || []
            this.dimension0 = this.dimension
          } else {
            this.dimension = this.dimension0
            return this.$message.error(resp.data.message || '获取错误')
          }
        } finally {
          this.isloading = false
        }
      }
    },

    onServiceChange(service) {
      this.$emit('update:service', service)
    },

    onOpenUser(row) {
      this.isopenUser = true
      this.openUser = row || {}
    },
  },
}
</script>

<style lang="scss" scoped>
.firstlog-path-chart-header {
  display: flex;
  flex-direction: row;
  height: 30px;
  align-items: center;

  .service-dropdown {
    margin-left: 20px;
    color: #979797;
    cursor: pointer;
    border-radius: 4px;
    padding: 5px;
    transition: background-color 0.3s;

    .service-down-icon {
      opacity: 0;
      transition: opacity 0.3s, transform 0.3s;

      &.opened {
        transform: rotate(180deg);
      }
    }

    &:hover {
      background-color: #efefef;

      .service-down-icon {
        opacity: 1;
      }
    }
  }
}

.info-successful-count,
.info-uname {
  font-weight: bold;
  margin-right: 5px;
}

.info-count {
  font-weight: bold;
  margin-left: 5px;
}
</style>
